export default __webpack_public_path__ + "static/media/kitten4M.4136740b.webp";